@if (card(); as card) {
  <article class="card cta-card card-body" [ngClass]="size() ? 'cta-card--' + size() : ''">
    <div class="cta-card__body d-flex mb-4">
      <header class="cta-card__header" [class.pt-4]="!card.image?.url">
        <h2 class="cta-card__title h4">{{ card.title }}</h2>
        @if (card.text) {
          <div
            class="mb-0 cta-card__intro"
            fstrDynamicContent
            [innerHTML]="card.text! | resizeHtmlImages | stripEmbed: undefined | safe"
          ></div>
        }
      </header>
      <!-- @if ((card.image && size() !== 'small') || (size() === 'small' && !card.smallImage)) { -->
      @if (!card.smallImage && card.image?.url) {
        <figure class="cta-card__image ms-xl-3">
          <fstr-image
            [class.is--figure]="card?.smallImage && size() === 'small'"
            class="card__image__media"
            [image]="card.image!"
            [width]="300"
            [height]="300"
            [scale]="'both'"
          ></fstr-image>
        </figure>
      }
      @if (size() === 'small' && card.image?.url && card.smallImage) {
        <figure class="cta-card__figure">
          <fstr-image class="card__figure__media" [image]="card.image!" [width]="300" [height]="300" [scale]="'both'"></fstr-image>
        </figure>
      }
    </div>
    @if (card.button?.url || card.secondaryButton?.url) {
      <footer class="cta-card__footer mt-auto d-flex flex-wrap gap-2 gap-md-3 gap-xl-4">
        @if (card.button?.url) {
          <fstr-link [button]="card.button!" [cssClasses]="'button button-outline'">
            <fstr-icon anchor="icon-arrow-right" [title]="'Lees meer'"></fstr-icon>
          </fstr-link>
        }
        @if (card.secondaryButton?.url) {
          <fstr-link [button]="card.secondaryButton!" [cssClasses]="'button button-link'"></fstr-link>
        }
      </footer>
    }
  </article>
}
